import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translationDe } from './i18n/de.js';
import { translationDe_AT_Gilde } from './i18n/de_AT_Gilde.js';
import { translationDe_AT_PPOE } from './i18n/de_AT_PPOE.js';
import { translationDe_AT_Suedtirol } from './i18n/de_AT_Suedtirol.js';

i18next
    .use(initReactI18next)
    .init({
        debug: true,
        // lng: 'de-AT-PPOE',
        // fallbackLng: 'cimode',
        fallbackLng: 'de',
        resources: {
            'de': translationDe,
            'de-AT-PGOE': translationDe_AT_Gilde,
            'de-AT-PPOE': translationDe_AT_PPOE,
            'de-IT-SP': translationDe_AT_Suedtirol,
        }
    })